import React, { useState } from 'react'
import Header from '../../common/header'
import Footer from '../../common/footer'
import SvgIcon from '../../common/svg-icon/svg-icon'
import { Button, Breadcrumb, Input } from 'semantic-ui-react'
import './index.scss'

import Ankit from '../../../assets/images/new-images/Ankit.jpg';
import Charmee from '../../../assets/images/new-images/Charmee.jpg';
import Amit from '../../../assets/images/new-images/Amit.jpeg';
import Vision from '../../../assets/images/new-images/vision.jpg';
import { NewInviteUser } from '../../common/newInviteUser';
import SEO from '../../../components/seo/SEO'
const AboutUs = () => {
  const sections = [
    { key: 'Home', content: 'Home', link: true, href: '/' },
    { key: 'about', content: 'About Us', link: false },
  ]

  const MappesFaces = [
    {
      id: 1,
      name: 'Ankit Singhal',
      title: 'Co-founder & CEO',
      descr: 'Over 15  years of experience with B2B sales of high technology industrial products working with advanced technology companies, globally. Highly connected with many global industries behemonths and varied manufacturing industries supporting sales and marketing of emerging technologies',
      address: 'New Delhi, India',
      graduation: 'M.S in Electrical Engineering. USC',
      image: Ankit,
    },
    {
      id: 1,
      name: 'Charmee Patel',
      title: 'Co-founder & Data Scientist',
      descr: 'Well versed using large scale data and AI to drive results out of digital marketing, personalisation, customer analytics and digital transformation initiatives of largest brands in B2C world. Built and led data teams at multiple start-ups in early and late stage',
      address: 'Virginia, USA',
      graduation: 'M.S in Computer Science, USC , Data Science, University of Washington',
      image: Charmee,
    },
    {
      id: 1,
      name: 'Amit Bhatnagar',
      title: 'Co-founder & CTO',
      descr: 'Built successful SaaS products at multiple startups starting from seed stage to late stage. Well versed with software design, architecture, and development using cloud, serverless and modern technologies. Experience in building and scaling software teams of various sizes',
      address: 'Virginia, USA',
      graduation: 'M.S in Computer Science, USC',
      image: Amit,
    },
  ];

  return (
    <>
      <SEO key="new-aboutus-seo"
        robots="index, follow"
        canonicalUrl="/aboutus"
        alternateLink="/aboutus"
        pageType={'aboutus'}

      />
      <Header />
      <div className='aboutpage-view'>
        <section className='breadcrumb-section'>
          <div className='mappes-container'>
            <Breadcrumb icon={<SvgIcon name='chevron-right' viewbox="0 0 8 14" />} sections={sections} />
          </div>
        </section>
        <section className='banner-section'>
          <div className='mappes-container'>
            <div className='banner-card'>
              <div><SvgIcon className='banner-logo' name='mappes-logo' viewbox='0 0 136 16' /></div>
              <div><h2>Revolutionizing <br /> Industrial Partnership</h2></div>
              <p>At Mappes.io, we connect global innovation with Indian industry. Our mission is simple: bring the world's best manufacturing technologies to the companies that need them most.</p>
            </div>
            <div className='bannerrow-2'>
              <div className='banner-card2 col1'>
                <h3>Redefining High-Tech  Manufacturing</h3>
                <p>
                  Founded in 2017 in Virginia, USA, and operating in India, we saw a problem: great tech often struggled to reach the right businesses. So, we created a solution: an AI-powered platform that links buyers and sellers in high-tech sectors like Solar, Semiconductor, and Li-Ion.
                </p>
              </div>
              <div className='banner-card2 col2'>
                <h2>“We believe in an ecosystem where a solar panel manufacturer in India can seamlessly connect with a cutting-edge materials supplier in Germany, or where a startup with a revolutionary carbon fiber technology can instantly reach potential customers across the globe. We desire to turn complexity into opportunity.”</h2>
              </div>
            </div>
          </div>
        </section>
        <section className='vision-section'>
          <div className='mappes-container'>
            <h2 className='main-heading text-left'><span>Our Vision:</span> Bridging the Global Industrial Ecosystem</h2>
            <div className='vision-row'>
              <div className='vision-image-col'>
                <img src={Vision} alt='' />
              </div>
              <div className='vision-text-col'>
                <ul>
                  <li>
                    <div className='left-num'>1</div>
                    <div className='right-text'>
                      We're breaking down geographical and industry barriers to create a seamlessly connected global manufacturing ecosystem.
                    </div>
                  </li>
                  <li>
                    <div className='left-num'>2</div>
                    <div className='right-text'>
                      We accelerate technological advancement by illuminating innovation pathways and forging borderless connections across high-tech manufacturing sectors.
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <section className='customersuccess-section'>
          <div className='mappes-container'>
            <h2 className='main-heading text-left'>40 Years of High-Tech Sales in India</h2>
            <ol>
              <li>
                <h3>Accelerate Your Growth in India’s High-Tech Market</h3>
                <p>Whether you're a global innovator entering India or an Indian manufacturer exploring advanced technologies, we help you move faster—from discovery to execution. </p>
              </li>
              <li>
                <h3>Your Edge: Our Legacy in High-Tech Sales</h3>
                <p>With 40+ years in optical fiber, semiconductors, solar, and carbon fiber, we’ve helped top manufacturers scale in India—guiding everything from first meetings to commissioning and after-sales support.</p>
              </li>
              <li>
                <h3>Smarter Discovery Starts Here</h3>
                <p>Our platform, Mappes.io, connects the entire high-tech value chain—technologies, suppliers, raw materials, applications—so you discover what’s possible, faster.</p>
              </li>
              <li>
                <h3>Execution You Can Count On</h3>
                <p>We don’t stop at introductions. We support you through pricing discussions, site meetings, trials, and post-sales service—turning opportunities into outcomes.</p>
              </li>
              <li>
                <h3>Data-Drive Insights</h3>
                <p>Our AI-powered analytics offered accurate market predictions, enabling informed decision-making. The company used these insights to forecast demand and customize their production plans, increasing their market share by 30% in just six months.</p>
              </li>
              <li>
                <h3>End-to-End Support</h3>
                <p>We offered comprehensive assistance, from initial market research to ongoing after-sales support. This allowed the company to focus on their core competencies while rapidly scaling their Indian operations.</p>
              </li>
              <li>
                <h3>Who We Work With</h3>
                <p>
                  <ul>
                    <li>Global companies entering or expanding in India.</li>
                    <li>Indian manufacturers sourcing advanced equipment and materials.</li>
                    <li>Engineering and R&D teams exploring new tech.</li>
                    <li>Supply chain leaders looking for long-term partners.</li>
                  </ul>
                </p>
              </li>
              <li>
                <h4>
                  "Partnering with Mappes.io has been transformative for our global expansion strategy," says the company's Head of Global Expansion. "What would have taken us a year or more, Mappes accomplished in weeks. It's not just about the speed of market entry - it's about the quality of connections and the depth of market understanding we've gained."
                </h4>
              </li>
            </ol>
          </div>
        </section>
        <section className='facebehind-section'>
          <div className='mappes-container'>
            <h1 className='main-heading text-left'>The Faces behind <span>Mappes.io</span>!</h1>
            <div className='facebehind-row'>

              {MappesFaces.map((faces) => (
                <div className='facebehind-col'>
                  <div className='image-col'>
                    <img src={faces.image} alt='' />
                  </div>
                  <h4>{faces.name}</h4>
                  <label>{faces.title}</label> <br />
                  <label>{faces.address}</label>
                  <p>
                    {faces.descr}
                  </p>
                </div>
              ))}



            </div>
          </div>
        </section>
        <section className='mappessubcribe-section'>
          <div className='mappes-container'>
            <div className='mappessubcribe-card'>
              <div className='mappessubcribe-row'>
                <h2>Discover and source the right advanced technology for your manufacturing with <span>Mappes.io</span></h2>
                <NewInviteUser />
                
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  )
}

export default AboutUs